import React from 'react'
import { Route, Routes } from "react-router-dom";
import Page404 from '../pages/page-404/Page404';
import Home from '../pages/home/Home';
import Game from '../pages/game/Game';


// for toastify
import 'react-toastify/dist/ReactToastify.css';

//toastify configuration
import { toast } from "react-toastify";
toast.configure();

export default function AppRoutes() {
    return (
        <>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/game/:voucher_id" element={<Game />} />
                <Route path="*" element={<Page404 />} />
            </Routes>

        </>
    )
}
